import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/email/logs');

export function getEmailStats() {
	return http.get('/admin/email/stats').then(resp => resp.data);
}
